import { ChangeDetectorRef, Component } from '@angular/core';

import { DeviceDetectorService } from 'ngx-device-detector';

import { AdsBase } from '../ads.base';


@Component({
    selector: 'app-ads[mobile-header]',
    templateUrl: './mobile-header.component.html',
    styleUrls: ['./mobile-header.component.scss'],
})
export class AdsMobileheaderComponent extends AdsBase {
    public constructor(public deviceService: DeviceDetectorService, protected ref: ChangeDetectorRef) {
        super(deviceService, ref);
    }
}
